// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vSfff0CP31J465 {
  display: inline-flex;
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-050, 4px);
  border: none;
  border-radius: var(--ds-radius-small, 3px);
  font-size: 12px;
  line-height: 12px;
  text-decoration: none;
}
.ibcQw6oAY5fpLq {
  display: flex;
  justify-content: center;
  width: 12px;
  height: 12px;
  margin-right: var(--ds-space-050, 4px);
  line-height: 12px;
}
.ibcQw6oAY5fpLq > span {
  width: 12px;
  height: 12px;
}
.FOYw6cwHaJAj0y {
  background-color: var(--ds-background-discovery, #f3f0ff);
  color: var(--ds-text-subtle, #44546f);
}
.FOYw6cwHaJAj0y .ibcQw6oAY5fpLq svg {
  color: var(--ds-icon-discovery, #8270db);
}
.FOYw6cwHaJAj0y:hover {
  background-color: var(--ds-background-discovery-hovered, #dfd8fd);
  color: var(--ds-text-subtle, #44546f);
}
.rEZxBE96vthfr4 {
  background-color: var(--ds-background-discovery-bold, #6e5dc6);
  color: var(--ds-text-inverse, #ffffff);
}
.rEZxBE96vthfr4 .ibcQw6oAY5fpLq svg {
  color: var(--ds-icon-inverse, #ffffff);
}
.rEZxBE96vthfr4:hover {
  background-color: var(--ds-background-discovery-bold-hovered, #583f68);
  color: var(--ds-text-inverse, #ffffff);
}
`, ""]);
// Exports
export var upgradePromptPill = `vSfff0CP31J465`;
export var upgradePromptPillIcon = `ibcQw6oAY5fpLq`;
export var upgradeLightTheme = `FOYw6cwHaJAj0y`;
export var upgradeDarkTheme = `rEZxBE96vthfr4`;
export default ___CSS_LOADER_EXPORT___;
